import React from "react";
import { Button } from "@chakra-ui/react";

const GoogleMap = () => {
  return <div>GoogleMap</div>;
};

export default GoogleMap;
